import { createRequestActionTypes } from "../shared/utility";

export const SharedActions = {
    uploadDocument: createRequestActionTypes('UPLOAD_DOCUMENT'),
}